import React from "react";
import PropTypes from "prop-types";
import {
  CardContainer,
  CardDetails,
  CardTitle,
  CardImage,
  CardBadges,
  CardBadge,
} from "./StoryCard.styled";

const StoryCard = ({
  title,
  image,
  children,
  bgColor,
  link,
  badges,
  highlightColor,
}) => {
  return (
    <CardContainer elevation={5} $bgColor={bgColor} href={link}>
      {image && <CardImage component="img" image={image} alt={title} />}
      <CardDetails sx={{ width: "100%" }}>
        <CardTitle sx={{ fontSize: 18 }} gutterBottom>
          {title}
        </CardTitle>
        {children}
        <CardBadges>
          {badges.map((badge, index) => (
            <CardBadge key={index} $highlightColor={highlightColor}>
              {badge}
            </CardBadge>
          ))}
        </CardBadges>
      </CardDetails>
    </CardContainer>
  );
};
StoryCard.propTypes = {
  bgColor: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  badges: PropTypes.array,
  children: PropTypes.node,
  image: PropTypes.string,
  link: PropTypes.string,
  highlightColor: PropTypes.string,
};
StoryCard.defaultProps = {
  title: "",
  image: "",
  children: null,
  badges: [],
  bgColor: "dark",
};
export default StoryCard;
